/* Site copy - taken word for word from the original cgeyer.co.za site */

export const HERO = {
  titleLines: [
    "Hi, I’m Corlea!",
    "Your Trusted Conveyancer.",
  ],
  lead: "Empowering Clients with Trust, Integrity and Results",
};

export const SERVICES = {
  tag: "Services",
  title: "Committed to excellence",
  items: [
    {
      title: "Property and Conveyancing Services",
      text: "Comprehensive assistance with the buying, selling, and transferring of property ownership, ensuring all legal requirements are met and transactions are completed efficiently and accurately.",
    },
  ],
};

//The conveyancing process, shown as a slideshow under the services
export const STEPS = [
  {
    title: "Agreement and Documentation",
    points: [
      "Seller and purchaser sign the offer to purchase.",
      "Transferring attorney requests FICA documents, compliance certificates, deposit, and transfer costs.",
    ],
  },
  {
    title: "Deposit and Bond Approval",
    points: [
      "Purchaser pays the deposit into the attorney’s trust account.",
      "Bank approves the bond and appoints bond registration attorneys.",
    ],
  },
  {
    title: "Bond Cancellation",
    points: [
      "Existing bondholder appoints bond cancellation attorneys.",
      "Attorneys provide bond cancellation figures and title deed to transferring attorneys.",
    ],
  },
  {
    title: "Document Signing",
    points: [
      "Transfer documents are drafted, and both parties sign with the transferring attorney.",
      "Purchaser signs bond documents with bond registration attorneys.",
    ],
  },
  {
    title: "Clearances and Compliance",
    points: [
      "Purchaser pays pro forma transfer costs.",
      "Seller provides compliance certificates, and attorneys secure clearance figures for rates, levies, and transfer duty.",
    ],
  },
  {
    title: "Guarantees and Preparation",
    points: [
      "Bond registration attorneys issue guarantees for the purchase price.",
      "Attorneys ensure all suspensive conditions are met.",
    ],
  },
  {
    title: "Lodgement in Deeds Office",
    points: [
      "Attorneys coordinate simultaneous lodgement of documents in the Deeds Office.",
    ],
  },
  {
    title: "Deeds Office Examination",
    points: [
      "Documents are examined and prepared for registration. All finances must be in order.",
    ],
  },
  {
    title: "Registration",
    points: [
      "Purchaser becomes the new owner, and the seller’s bond is canceled.",
      "Final payments and statements are processed within 2-3 days of registration.",
    ],
  },
  {
    title: "Title Deed Release",
    points: [
      "Deeds Office releases title deed and bond after 3-6 months for delivery to the owner or bondholder.",
    ],
  },
];

export const ABOUT = {
  tag: "About",
  title: "About me",
  paragraphs: [
    "With over 24 years of expertise as an attorney and conveyancer, Corlea Geyer has built a career rooted in legal excellence and client advocacy. After earning her BProc and LLB degrees, Corlea gained invaluable experience at a prestigious law firm, specializing in property law, contract negotiations, and dispute resolution.",
    "As a licensed conveyancer, Corlea has successfully overseen countless real estate transactions across South Africa, ensuring compliance with legal standards while safeguarding the interests of clients and estate agents alike. Her skill set extends to commercial law, where she helps businesses navigate complex legal frameworks, fostering growth and minimizing risks.",
    "Since founding her own practice in 2001, Corlea has delivered tailored legal solutions with a focus on integrity, professionalism, and client-centric service. Under her leadership, the practice emphasizes a team-oriented approach and continuous learning.",
  ],
};

export const APPROACH = {
  tag: "Approach",
  title: "Building trust & open communication",
  text: "Beyond her practice, Corlea actively contributes to the legal profession as a member of multiple associations, championing ethical practices in the field. Her dedication to empowering clients through expert legal counsel is matched by her focus on building trust and maintaining open communication. Corlea remains committed to guiding clients through their unique legal challenges with clarity and confidence.",
};

export const CONTACT = {
  title: "Get in touch",
};
